import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenDocMultiSessionContainerModel } from "../../../../../../models/aggregates/generic_doc";
import { GenDocMultiPoDTO } from "../../../data-transfer-objects";
import {
  ApiResponseModel,
  ApiVisa,
  BasicApiResponseModel,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({ providedIn: "root" })
export class GenericDocMultiSessionService extends BaseApiTemplateService<GenDocMultiSessionContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc/multi-session";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc/multi-session";
    this.httpClient = http;
  }

  createMultiPO(
    dtoObject: GenDocMultiPoDTO,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl =
        visa.api_domain_url + this.endpoint_path + "/multi-po/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + "/backoffice-ep/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + "/backoffice-ep/" + guid,
      this.getHttpHeader(visa)
    );
  }

  get(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/backoffice-ep";
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}
